// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__xEcJj","checkmark":"Checkbox_checkmark__Huc6G","text":"Checkbox_text__33s-5"};